<template>
  <Wizard #default="{getValue, getOptionSet}">
    <WizardStep name="intro">
      <Start title="Los geht's!">
        <p>
          Dies ist der erste Schritt zu Deiner Stelle beim REWE
          Lieferservice.<br />
          Folgendes solltest Du für Deine Bewerbung bereitlegen:
        </p>
        <ul class="mb-4">
          <li>E-Mail-Adresse</li>
          <li>Bewerbungsunterlagen als PDF, z.B. Lebenslauf</li>
        </ul>
        <p>
          Wenn Deine grundlegenden Angaben passen, laden wir Dich im nächsten
          Schritt zu einem persönlichen Gespräch ein, bei dem wir Dich
          kennenlernen können und das Dir die Gelegenheit gibt, Dich mit Deinen
          Erfahrungen und bisherigem Werdegang vorzustellen. Gerne klären wir
          dabei auch weitere Fragen.
        </p>
        <p>Wir freuen uns auf Deine Bewerbung!</p>
      </Start>
    </WizardStep>
    <PersonalTemplate />
    <AvailabilityTemplate />
    <DateOfBirthTemplate />
    <AddressTemplate />
    <WizardStep name="upload">
      <FieldGroup
        :title="`${getValue(
          'personal.firstname'
        )}, bitte lade Deine Bewerbungsunterlagen hoch.`"
        subtitle="Wir benötigen auf jeden Fall Deinen Lebenslauf. Wenn vorhanden, kannst Du außerdem ein persönliches Anschreiben und Arbeitszeugnisse hochladen."
      >
        <UploadField
          name="documents"
          :dropzone-options="{
            url: getOptionSet('apiuploadendpoint'),
            acceptedFiles: 'application/pdf',
            maxFiles: 5,
            maxFilesize: 4,
          }"
          help="Bitte lade die Unterlagen als PDF-Dokument(e) hoch (max. 4MB Dateigröße)."
        />
      </FieldGroup>
    </WizardStep>
    <WizardStep name="salaryExpectations">
      <FieldGroup title="Bitte nenne Deine Gehaltsvorstellung">
        <TextField placeholder="Gehaltsvorstellung in Euro" name="salary" />
      </FieldGroup>
    </WizardStep>
    <PersonalSummaryTemplate>
      <SummaryGroup>
        <SummaryRow
          :value="
            getValue('upload.documents', [])
              .map((file) => file.original)
              .join('<br/>')
          "
          label="Dokumente"
          checked
        />
        <SummaryRow
          :value="getValue('salaryExpectations.salary', '')"
          label="Gehaltsvorstellungen"
        />
      </SummaryGroup>
    </PersonalSummaryTemplate>
    <WizardStep name="confirmation" confirmation>
      <Confirmation :email="getValue('personal.email')" />
    </WizardStep>
  </Wizard>
</template>

<script>
import AddressTemplate from '../../../clientside/wizard/templates/AddressTemplate.vue';
import AvailabilityTemplate from '../../../clientside/wizard/templates/AvailabilityTemplate.vue';
import DateOfBirthTemplate from '../../../clientside/wizard/templates/DateOfBirthTemplate.vue';
import PersonalSummaryTemplate from '../../../clientside/wizard/templates/PersonalSummaryTemplate.vue';
import PersonalTemplate from '../../../clientside/wizard/templates/PersonalTemplate.vue';

export default {
  components: {
    PersonalSummaryTemplate,
    AvailabilityTemplate,
    AddressTemplate,
    DateOfBirthTemplate,
    PersonalTemplate,
  },
};
</script>

<style lang="scss" scoped>
@use '~tokens/sass/utils';

.confirmation {
  width: 100%;
  margin: 0 auto;
  padding-bottom: utils.f-rem-calc(utils.$v-wizard-sm-gap-y);
  text-align: center;

  @include utils.bs-media-breakpoint-up(md) {
    padding: utils.f-rem-calc(40) utils.f-rem-calc(100) 0;
  }

  @include utils.bs-media-breakpoint-up(lg) {
    padding: utils.f-rem-calc(0) utils.f-rem-calc(100);
  }

  @at-root #{&}__section {
    margin-bottom: utils.f-rem-calc(50);

    @at-root #{&}--has-image {
      display: flex;
    }
  }

  @at-root #{&}__content {
    > * {
      margin-bottom: 0;

      + * {
        margin-top: 10px;
      }
    }

    h2 {
      font-size: 28px;
      margin: 0;
    }

    p {
      line-height: 1.5;
    }
  }

  @at-root #{&}__image {
    margin-right: 16px;
    flex-shrink: 0;
  }

  @at-root #{&}__cta {
    display: flex;
    justify-content: center;
  }
}
</style>
